import { render, staticRenderFns } from "./AssignmentLink.vue?vue&type=template&id=0cc0a8e5"
import script from "./AssignmentLink.vue?vue&type=script&lang=js"
export * from "./AssignmentLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports